import React, { useState } from 'react';
import clsx from "clsx";

import {putData} from '../dataLib'

//COMPONENT
import Snackbar from "../components/Snackbar/Snackbar";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: "10px",
        display: "flex",
    },
    form: {
        width: "90%",
        marginTop: theme.spacing(3),
        paddingBottom: "20px",
    },
    disabled: {},
}));
//#endregion

function ChangePasswordDialog(props) {
    const classes = useStyles();
    const [formValues, setFormValues] = useState({
        showSnackBar: false,
        snackMessage: "Contraseña modificada",
        showPassword: false,
        edit: true,
        editPassword: true,
        errorMessage: "",
    });
    const [values, setValues] = useState({
        oldPassword: "",
        password: "",
        repassword: "",
    });
    const [checkValues, setCheckValues] = useState({
        oldPassword: false,
        password: false,
        repassword: false,
    });

    //#region OnBlur
    const handleBlur = prop => event => {
        let check = checkSpecialCondition(prop, event.target.value);
        setValues({
            ...values,
            [prop]: event.target.value,
        });
        setCheckValues({
            ...checkValues,
            [prop]: check.check,
        });
        setFormValues({
            ...formValues,
            errorMessage: check.errorMessage,
        });
    };
    //#endregion

    //#region Function
    const checkSpecialCondition = (atribute, value) => {
        let result = {
            check: false,
            errorMessage: "",
        };
        switch (atribute) {
            case "password":
                if (!/^[a-z0-9_-]{3,}$/i.test(value)) {
                    result.check = true;
                    result.errorMessage = "La contraseña debe tener como mínimo 3 caracteres.";
                } else {
                    result.check = false;
                    result.errorMessage = "";
                }
                break;
            case "repassword":
                if (values.password !== value) {
                    result.check = true;
                    result.errorMessage = "Las contraseñas deberian coincidir.";
                } else {
                    result.check = false;
                    result.errorMessage = "";
                }
                break;
            default:
                break;
        }

        return result;
    };
    const handleChange = prop => event => {
        setValues({
            ...values,
            [prop]: event.target.value,
        });
        setCheckValues({
            ...checkValues,
            [prop]: false,
        });
    };
    const handleChangeFormValuesBoolean = prop => event => {
        setFormValues({
            ...formValues,
            [prop]: !formValues[prop],
        });
    };
    const handleMouseDownPassword = event => {
        event.preventDefault();
    };
    //#endregion

    //#region OnSubmit
    const onSubmitChangePassword = () =>{
        putData('Usuarios/changePassword/'+props.userProfile.profile.id
        ,v=>{
            setFormValues({...formValues,showSnackBar:true})
            setTimeout(()=>{
                props.hideDialog();
            },1000);
        },e=>{
            setFormValues({...formValues,errorMessage: "Error en la contraseña"});
        },{password:values.password,oldPassword:values.oldPassword}
        ,props.user);
    }
    //#endregion

    //#region Displays
    const displayTextFieldTitle = () => {
        return <Grid item xs={10}>
            <Box textAlign="center">
                <Typography color="secondary" variant="h5">
                    {"Editar contraseña"}
                </Typography>
            </Box>
        </Grid>;
    }
    const displayTextFieldError = () => {
        return formValues.errorMessage.length > 0 ? (
            <Grid item xs={12}>
                <div className="alert alert-danger" role="alert">
                    {formValues.errorMessage}
                </div>
            </Grid>
        ) : null;
    }
    const displayInputOldPassword = () => {
        return <Grid item xs={12}>
            <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-old-password" error={checkValues.oldPassword ? true : false}>
                    Contraseña actual *
                </InputLabel>
                <OutlinedInput
                    id="outlined-adornment-old-password"
                    type={formValues.showPassword ? "text" : "password"}
                    value={values.oldPassword}
                    autoFocus
                    error={checkValues.oldPassword ? true : false}
                    autoComplete="old-password"
                    onChange={handleChange("oldPassword")}
                    disabled={!formValues.edit}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleChangeFormValuesBoolean("showPassword")}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                    labelWidth={155}
                />
            </FormControl>
        </Grid>;
    }
    const displayInputPassword = () => {
        return <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" fullWidth>
            <InputLabel htmlFor="outlined-adornment-password" error={checkValues.password ? true : false}>
                {formValues.editPassword ? "Contraseña nueva * (min. 3)" : "Contraseña * (min. 3)"}
            </InputLabel>
            <OutlinedInput
                id="outlined-adornment-password"
                type={formValues.showPassword ? "text" : "password"}
                value={values.password}
                error={checkValues.password ? true : false}
                autoComplete="new-password"
                onChange={handleChange("password")}
                onBlur={handleBlur("password")}
                disabled={!formValues.edit}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleChangeFormValuesBoolean("showPassword")}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
                labelWidth={formValues.editPassword ? 210 : 160}
            />
        </FormControl>;
    }
    const displayInputRePassword = () => {
        return <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" fullWidth>
            <InputLabel htmlFor="outlined-adornment-repassword" error={checkValues.repassword ? true : false}>
                Repetir contraseña *
            </InputLabel>
            <OutlinedInput
                id="outlined-adornment-repassword"
                type={formValues.showPassword ? "text" : "password"}
                value={values.repassword}
                error={checkValues.repassword ? true : false}
                autoComplete="new-password"
                onChange={handleChange("repassword")}
                onBlur={handleBlur("repassword")}
                disabled={!formValues.edit}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleChangeFormValuesBoolean("showPassword")}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
                labelWidth={163}
            />
        </FormControl>;
    }
    //#endregion


    return (
        <Grid container spacing={1} justify="center" alignItems="center">
            <Snackbar show={formValues.showSnackBar}
                setShow={v => { setFormValues({ ...formValues, showSnackBar: v }); }}
                message={formValues.snackMessage}
            />
            {displayTextFieldTitle()}
            <form className={classes.form} noValidate>
                <Grid container spacing={2}>
                    {displayTextFieldError()}
                    {/* Passwords */}
                    {displayInputOldPassword()}
                    <Grid item xs={12} sm={formValues.editPassword ? 12 : 6}>
                        {displayInputPassword()}
                    </Grid>
                    <Grid item xs={12} sm={formValues.editPassword ? 12 : 6}>
                        {displayInputRePassword()}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button fullWidth variant="contained" color="secondary" onClick={() => props.hideDialog()}>
                            Atrás
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button fullWidth variant="contained" color="primary"
                            style={{ color: "white" }}
                            onClick={e => {
                                e.preventDefault();
                                onSubmitChangePassword();
                            }}>
                            Cambiar contraseña
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Grid >
    );
}

export default ChangePasswordDialog;